


























































































import Vue from 'vue';
import axios from 'axios';

export default Vue.extend({
  name: 'SettingsCars',
  data: () => ({
    tableData: [],
    modalEdit: false,
    modalDelete: false,
    userGroups: [],
    validForm: false,
    search: '',
    place: {
      ID: 0,
      name: '',
      IDgroups: 0,
    },
    headers: [
      { text: 'Jméno', value: 'name', width: '50%' },
      { text: 'Skupina', value: 'groupName', width: '50%' },
      { sortable: false, width: '48px' },
    ],
    rules: {
      required: (value: string) => !!value || 'Pole je povinné',
      number: (value: string) => {
        const pattern = /^\d+$/;
        return pattern.test(value) || 'Hodnota musí být číslo!!!';
      },
    },
  }),
  watch: {},
  mounted() {
    this.dataLoad();
    this.userGroupsLoad();
  },
  methods: {
    dataLoad() {
      axios
        .get('/api/v1/place')
        .then((response) => {
          this.tableData = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    dataNew() {
      this.place = { ...this.place, ...((this.$options as Vue & { data: () => object }).data() as Vue & { place: object }).place };
      this.modalEdit = true;
      this.$nextTick(function () {
        (this.$refs.placeForm as Vue & { validate: () => boolean }).validate();
      });
    },
    dataSave() {
      if ((this.$refs.placeForm as Vue & { validate: () => boolean }).validate() !== true) {
        this.$store.commit('globalMessage', 'Formulář obsahuje chyby!!!');
      } else {
        if (this.place.ID === 0) {
          axios
            .post('/api/v1/place', this.place)
            .then(() => {
              this.dataLoad();
              this.modalEdit = false;
            })
            .catch((err) => {
              this.$store.dispatch('catchErrHandler', err);
            });
        } else {
          axios
            .put(`/api/v1/place/${this.place.ID}`, this.place)
            .then(() => {
              this.dataLoad();
              this.modalEdit = false;
            })
            .catch((err) => {
              this.$store.dispatch('catchErrHandler', err);
            });
        }
      }
    },
    dataDelete() {
      axios
        .delete(`/api/v1/place/${this.place.ID}`)
        .then(() => {
          this.dataLoad();
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
      this.modalEdit = false;
      this.modalDelete = false;
    },
    userGroupsLoad() {
      axios
        .get('/api/v1/group')
        .then((response) => {
          this.userGroups = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
  },
});
